import type { Client } from '@src/clients/domain/Client';
import { useNavigateBack } from '@src/common/hooks/useNavigateBack';
import { useToast } from '@src/common/hooks/useToast';
import { ClientsNavigation } from '@src/routing/ClientsNavigation';
import { useCreateTractor } from '@src/tractor/hooks/useCreateTractor';
import { useTranslation } from 'react-i18next';

import { TractorPageContent } from './TractorPageContent';

type Props = {
  client: Client;
};

export const AddTractorPage = ({ client }: Props) => {
  const { t } = useTranslation();
  const { goBack } = useNavigateBack({
    defaultPath: ClientsNavigation.get.url(client.id, 3),
  });

  const { showSuccessToast, showErrorToast } = useToast();

  const { createTractor, isLoading } = useCreateTractor({
    clientId: client.id,
    onSuccess: (_) => {
      showSuccessToast(t('createTractor.success'));
      goBack();
    },
    onError: () => {
      showErrorToast(t('createTractor.error'));
    },
  });

  return (
    <TractorPageContent
      client={client}
      onSubmit={createTractor}
      onBack={goBack}
      onCancel={goBack}
      isLoading={isLoading}
    />
  );
};
